import React from 'react'


const Loading: React.FC = function () {
  return <>
    <h2>努力加载中......</h2>
  </>
}


export default Loading